import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { DialogHelper } from "helpers";
import history from "routers/history";
import { I18nTranslator, translations } from "utils/i18n";
// SkipNegotiation = true;
// Transports = HttpTransportType.WebSockets;
class InprocessSignalRService {
  private instance: HubConnection;
  constructor(token: string) {
    this.instance = this.setUpService(token);
  }
  public setUpService(token: string) {
    const BASE_API = process.env.REACT_APP_BASE_API;
    const hubConnectionBuilder = new HubConnectionBuilder()
      .configureLogging(LogLevel.Information)
      .withUrl(BASE_API + "/notification-hub", {
        withCredentials: false,
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: () => {
          return token;
        },
      })
      .withAutomaticReconnect();

    var connection = hubConnectionBuilder.build();
    connection.serverTimeoutInMilliseconds = 120000;
    connection.keepAliveIntervalInMilliseconds = 60000;

    return connection;
  }
  public runService() {
    try {
      this.remove();
      this.instance.start().then(() => {
        if (this.instance.connectionId) {
          console.log("Connected");
        }
      });
      this.instance.onreconnected((connectionString) =>
        console.log("Reconnected: Connection String", connectionString)
      );
    } catch (error) {
      setTimeout(() => {
        this.runService();
      }, 5000);
    }
  }
  public onClose() {
    this.instance.onclose((error) => {
      console.log("HUB CLOSED WITH ERROR: =>>", error);
      // this.runService();
    });
  }

  public onNotificationHub() {
    this.instance.on(
      EVENTS_NAME.RECEIVED_MESSAGE,
      (data: {
        productLot: string;
        productCode: string;
        productName: string;
        id: string;
      }) => {
        this.playAlert();
        this.showNotification(
          data.productLot,
          data.productCode,
          data.productName
        );
        DialogHelper.open({
          title: I18nTranslator(
            translations.inProcessCheckReportDetail.inprocessCheckReminderTitle
          ),
          message: I18nTranslator(
            translations.inProcessCheckReportDetail
              .inprocessCheckReminderMessage,
            {
              lot: data.productLot,
              code: data.productCode,
              name: data.productName,
            }
          ),
          isCancel: true,
          onConfirm: () => {
            history.replace(
              process.env.PUBLIC_URL + "/inprocess-check/" + data.id
            );
            //dont know why have to do this
            history.push("/");
            history.go(-1);
            this.stopAlert();
          },
          onCancel: () => {
            //invoke
            this.instance.invoke(EVENTS_NAME.IGNORE);
            this.stopAlert();
          },
        });
      }
    );
  }

  public remove() {
    if (this.instance) {
      this.instance.stop();
    }
  }

  public invoke(event: string) {
    this.instance.invoke(event);
  }

  public playAlert = () => {
    (document.getElementById("alert") as HTMLAudioElement).play();
  };

  public stopAlert = () => {
    (document.getElementById("alert") as HTMLAudioElement).pause();
  };

  private showNotification = (lot: string, code: string, name: string) => {
    if (Notification.permission === "granted") {
      // Check whether notification permissions have already been granted;
      // if so, create a notification
      const notification = new Notification(
        I18nTranslator(
          translations.inProcessCheckReportDetail.inprocessCheckReminderTitle
        ),
        {
          body: I18nTranslator(
            translations.inProcessCheckReportDetail
              .inprocessCheckReminderMessage,
            { lot, code, name }
          ),
        }
      );
    }
  };
}

export const EVENTS_NAME = {
  IGNORE: "Ignore",
  PAUSE: "Pause",
  RESUME: "Resume",
  CLEAR: "Clear",
  RECEIVED_MESSAGE: "ReceivedMessage",
} as const;

export default InprocessSignalRService;
